module.exports = __webpack_public_path__ + "img/ad.4fc7c4c.svg";